import React from 'react';
import Modal from '../../commons/modal/modal';
import styles from './ceTaskboard.scss';

const DaccModal = props => (
  <Modal
    showModal={props.showModal}
    title={
      props.rowData && props.rowData.isConsignmentDacc
        ? 'Un-Mark DACC CN'
        : 'Mark DACC CN'
    }
    closeModal={props.closeModal}
    modalTheme={{
      name: 'themeGrey'
    }}
  >
    <div className={`l-col ${styles.modalContentWrapper}`}>
      <div className={`flex-100 l-row j-center a-center  ${styles.modalText}`}>
        Are you sure to{' '}
        {props.rowData && props.rowData.isConsignmentDacc
          ? 'Un-Mark '
          : 'Mark '}{' '}
        CN {props.rowData && props.rowData.cnote} DACC?
      </div>
      <div className="l-row j-end a-end">
        <div
          className={`${styles.cancelBtnWrapper} l-row j-center a-center`}
          onClick={props.closeModal}
        >
          NO
        </div>
        <div
          className={`${styles.submitBtnWrapper} l-row j-center a-center`}
          onClick={() => props.markUnmarkDacc(props.rowData, props.closeModal)}
        >
          YES
        </div>
      </div>
    </div>
  </Modal>
);

export default DaccModal;
